import { render, staticRenderFns } from "./BusinessCustomers.vue?vue&type=template&id=51c8897c&scoped=true&"
import script from "./BusinessCustomers.vue?vue&type=script&lang=js&"
export * from "./BusinessCustomers.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCustomers.vue?vue&type=style&index=0&id=51c8897c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8897c",
  null
  
)

export default component.exports